import { useState } from "react";
import type { Principal } from "../../controllers/oidc";
import { AdminLink } from "./AdminLink";
import { UserManagement } from "./UserManagement";

// Admin section: 유저 관리 (view/edit/deactivate/delete accounts) + 앱 링크 (register add-on apps).
export function AdminView({
  principal,
  getToken,
  onLinked,
}: {
  principal: Principal;
  getToken: () => string | null;
  onLinked: () => Promise<void>;
}) {
  const [tab, setTab] = useState<"users" | "apps">("users");
  return (
    <div className="detail">
      <div className="detail-name"><h1>관리자</h1></div>
      <div className="tabs">
        <button className={`tab ${tab === "users" ? "active" : ""}`} onClick={() => setTab("users")}>유저 관리</button>
        <button className={`tab ${tab === "apps" ? "active" : ""}`} onClick={() => setTab("apps")}>앱 링크</button>
      </div>
      {tab === "users"
        ? <UserManagement getToken={getToken} />
        : <AdminLink principal={principal} getToken={getToken} onLinked={onLinked} />}
    </div>
  );
}
